import { useEffect, useRef, useState } from 'react';

function useAbortableFetch(requestFn, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (typeof requestFn !== 'function') return undefined;

    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    let mounted = true;

    setIsLoading(true);
    setError(null);

    Promise.resolve(requestFn(abortController.signal))
      .then((result) => {
        if (!mounted) return;
        setData(result);
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') {
          // aborted
        } else {
          setError(err ? err.message || String(err) : 'Unknown error');
        }
      })
      .finally(() => {
        if (mounted) setIsLoading(false);
      });

    return () => {
      mounted = false;
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
    // deps intentionally controls when to re-run
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, error, isLoading };
}

export default useAbortableFetch;